export default "__VITE_ASSET__DWMywYEF__"